/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2026-04-26 17:20:07.

export interface ApiMenuFindResponse {
    menuItem: ApiMenuReadMenuItemDto;
}

export interface ApiMenuReadResponse {
    menuItem: ApiMenuReadMenuItemDto;
}

export interface ApiMenuResourcesSearchResponse {
    page: PageResultDto<ApiResourceDto>;
}

export interface ApiOrderDto {
    billingData: ApiOrderAddressDto;
    shippingData: ApiOrderAddressDto;
    items: ApiOrderItemDto[];
    note: string;
}

export interface ProductMenuResourcesSearchRequest {
    productId: string;
    productUrlId: string;
    lang: string;
    menuId: number;
    page: PageDto;
}

export interface ProductMenuResourcesSearchResponse {
    page: PageResultDto<ApiResourceDto>;
}

export interface ResourceSearchItemDto {
    id: string;
    externalId: string;
    name: string;
    type: ResourceType;
}

export interface ResourceSearchResponse {
    page: PageResultDto<ResourceSearchItemDto>;
}

export interface ApiStatusResponse {
}

export interface OrganizationAddressData {
    id: number;
    version: number;
    type: OrganizationAddressType;
    name: string;
    taxId: string;
    country: string;
    zip: string;
    city: string;
    state: string;
    lineOne: string;
    lineTwo: string;
    phone: string;
    email: string;
}

export interface UserResponse {
    id: number;
    userType: UserType;
    firstName: string;
    lastName: string;
    email: string;
    langKey: string;
    addresses: UserAddressData[];
    organizationAddresses: OrganizationAddressData[];
}

export interface OrderData {
    id: number;
    billingAddress: OrderAddressData;
    shippingAddress: OrderAddressData;
    status: OrderStatus;
    createdOn: Date;
    price: Amount[];
    note: string;
    items: OrderItem[];
}

export interface OrderPartLinkData {
    resourceId: string;
    viewBookmark: string;
    partRefId: string;
}

export interface OrderResponse {
    totalPages: number;
    totalElements: number;
    orders: OrderData[];
}

export interface UserProfileAddressDeleteRequest {
    addressId: number;
}

export interface UserProfileAddressDto {
    id: number;
    version: number;
    type: RetailUserAddressType;
    name: string;
    taxId: string;
    country: string;
    state: string;
    zip: string;
    city: string;
    addressLine1: string;
    addressLine2: string;
    phone: string;
    email: string;
}

export interface UserProfileAddressListResponse {
    addresses: UserProfileAddressDto[];
}

export interface UserProfileAddressSaveRequest {
    address: UserProfileAddressDto;
}

export interface UserProfileAddressSaveResponse {
    address: UserProfileAddressDto;
}

export interface UserProfileResponse {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    langKey: string;
}

export interface UserProfileUpdateRequest {
    firstName: string;
    lastName: string;
    email: string;
    langKey: string;
}

export interface AuthActivateAccountWithPasswordRequest {
    tokenUuid: string;
    password: string;
}

export interface AuthActivateAccountWithPasswordResponse {
    activated: boolean;
}

export interface AuthActivateTokenCheckResponse {
    valid: boolean;
    passwordReset: boolean;
    accountEmail: string;
    accountActive: boolean;
}

export interface AuthPasswordResetInitRequest {
    accountEmail: string;
}

export interface AuthPasswordResetRequest {
    tokenUuid: string;
    password: string;
}

export interface AuthPasswordResetResponse {
    activated: boolean;
}

export interface AuthPasswordResetTokenCheckResponse {
    valid: boolean;
    passwordReset: boolean;
    accountEmail: string;
}

export interface AuthTokenRefreshResponse {
    accessToken: string;
    refreshToken: string;
}

export interface AdminOrganizationAddressDeleteRequest {
    organizationId: number;
    addressId: OrganizationAddressId;
}

export interface AdminOrganizationAddressListResponse {
    addresses: OrganizationAddressValue[];
    legalAddress: OrganizationAddressValue;
}

export interface AdminOrganizationAddressSaveRequest {
    address: OrganizationAddressValue;
}

export interface AdminOrganizationAddressSaveResponse {
    address: OrganizationAddressValue;
}

export interface AdminOrganizationListAllRequest {
}

export interface AdminOrganizationListAllResponse {
    organizations: OrganizationNameValue[];
}

export interface AdminOrganizationListRequest {
    page: PageDto;
    criteria: OrganizationListCriteria;
}

export interface AdminOrganizationListResponse {
    resultPage: PageResultDto<OrganizationValue>;
}

export interface AdminOrganizationSaveRequest {
    organization: OrganizationValue;
}

export interface AdminOrganizationSaveResponse {
    organization: OrganizationValue;
}

export interface AdminUserAddressDeleteRequest {
    userId: UserId;
    addressId: number;
}

export interface AdminUserAddressListResponse {
    addressListByType: { [P in RetailUserAddressType]?: UserAddressValue[] };
}

export interface AdminUserAddressSaveRequest {
    address: UserAddressValue;
}

export interface AdminUserAddressSaveResponse {
    address: UserAddressValue;
}

export interface AdminUserCheckRequest {
    email: string;
    excludeUserId: number;
}

export interface AdminUserCheckResponse {
    exists: boolean;
}

export interface AdminUserCreateRequest {
    user: UserValue;
}

export interface AdminUserCreateResponse {
    result: UserCreationResult;
}

export interface AdminUserListRequest {
    page: PageDto;
    criteria: UserListCriteria;
}

export interface AdminUserListResponse {
    usersPage: PageResultDto<UserValue>;
}

export interface AdminUserUpdateRequest {
    user: UserValue;
}

export interface AdminUserUpdateResponse {
    userValue: UserValue;
}

export interface UserAccountDto {
    user: UserValue;
    switched: boolean;
    realUserName: string;
}

export interface AdminUserPermissionGroupListRequest {
    page: PageDto;
    criteria: UserResourcePermissionGroupCriteria;
    withPermissionDict: boolean;
}

export interface AdminUserPermissionGroupListResponse {
    permissionGroupsPage: PageResultDto<UserResourcePermissionGroupValue>;
}

export interface AdminUserPermissionGroupUpdateRequest {
    group: UserResourcePermissionGroupValue;
}

export interface AdminUserPermissionGroupUpdateResponse {
}

export interface OrganizationAddressValue {
    id: OrganizationAddressId;
    version: number;
    organizationId: number;
    addressType: OrganizationAddressType;
    name: string;
    taxId: string;
    country: string;
    state: string;
    zip: string;
    city: string;
    addressLine1: string;
    addressLine2: string;
    phone: string;
    email: string;
}

export interface AdminCorrespondenceEmailHistoryRequest {
    page: PageDto;
    criteria: EmailHistoryListCriteria;
}

export interface AdminCorrespondenceEmailResendRequest {
    emailId: EmailId;
}

export interface AdminEmailTemplateItemDto {
    id: string;
    version: number;
    emailGroup: EmailGroup;
    emailCode: EmailCode;
    lang: string;
    description: string;
    sender: string;
    subjectTemplate: string;
    bodyTemplate: string;
    recipients: string[];
    ccRecipients: string[];
    bccRecipients: string[];
}

export interface AdminEmailTemplateListRequest {
    page: PageDto;
    criteria: EmailTemplateCriteria;
}

export interface AdminEmailTemplateListResponse {
    templatesPage: PageResultDto<AdminEmailTemplateItemDto>;
}

export interface AdminEmailTemplatePreviewRequest {
    emailCode: EmailCode;
    subjectTemplate: string;
    bodyTemplate: string;
}

export interface AdminEmailTemplatePreviewResponse {
    renderedSubject: string;
    renderedBody: string;
}

export interface AdminEmailTemplateSaveRequest {
    id: string;
    version: number;
    description: string;
    sender: string;
    subjectTemplate: string;
    bodyTemplate: string;
    recipients: string[];
    ccRecipients: string[];
    bccRecipients: string[];
}

export interface AdminEmailTemplateSaveResponse {
    item: AdminEmailTemplateItemDto;
}

export interface EmailTemplateCriteria {
    emailGroup: string[];
    emailCode: string[];
    lang: string[];
    description: string;
    sender: string;
}

export interface AdminAutoMatchConfigDeleteRequest {
    id: string;
    version: number;
}

export interface AdminAutoMatchConfigItemDto {
    id: string;
    version: number;
    resourceType: ResourceType;
    matchAllProperties: boolean;
    propertyCodes: string[];
    active: boolean;
}

export interface AdminAutoMatchConfigSaveRequest {
    id: string;
    version: number;
    resourceType: ResourceType;
    matchAllProperties: boolean;
    propertyCodes: string[];
    active: boolean;
}

export interface AdminImportMappingDeleteRequest {
    id: number;
    version: number;
}

export interface AdminImportMappingItemDto {
    id: number;
    version: number;
    resourceType: ResourceType;
    valueTemplates: string[];
    propertyCode: string;
    propertyType: ResourcePropertyValueType;
    defaultValue: string;
    active: boolean;
}

export interface AdminImportMappingSaveRequest {
    id: number;
    version: number;
    resourceType: ResourceType;
    valueTemplates: string[];
    propertyCode: string;
    propertyType: ResourcePropertyValueType;
    defaultValue: string;
    active: boolean;
}

export interface AdminListAutoMatchConfigResponse {
    items: AdminAutoMatchConfigItemDto[];
}

export interface AdminListDictionaryPropertiesRequest {
    page: PageDto;
    criteria: ListDictionaryPropertiesCriteria;
}

export interface AdminListDictionaryPropertiesResponse {
    items: AdminImportMappingItemDto[];
    totalElements: number;
}

export interface AdminMenuItemNamesListRequest {
    actionTypes: MenuActionType[];
}

export interface AdminMenuItemCloneRequest {
    menuId: MenuId;
}

export interface AdminMenuItemCloneResponse {
    clonedMenuId: MenuId;
}

export interface AdminMenuItemDeleteRequest {
    menuId: MenuId;
}

export interface AdminMenuItemDeleteResponse {
    deleted: boolean;
}

export interface AdminMenuItemListChildrenRequest {
    parentId: MenuId;
    lang: string;
}

export interface AdminMenuItemListChildrenResponse {
    menuItems: MenuItemValue[];
}

export interface AdminMenuItemListRequest {
    page: PageDto;
    criteria: MenuItemListCriteria;
}

export interface AdminMenuItemListResponse {
    list: PageResultDto<MenuItemValue>;
}

export interface AdminMenuItemNamesListResponse {
    menuNames: MenuItemNameValue[];
}

export interface AdminMenuItemUpdateRequest {
    menuItem: MenuItemValue;
}

export interface AdminMenuItemUpdateResponse {
    menuItem: MenuItemValue;
}

export interface AdminCartUpdateRequest {
    cart: UserCartDto;
}

export interface AdminCartsQueryRequest {
    page: PageDto;
    criteria: UserCartListCriteria;
    lang: string;
}

export interface AdminCartsQueryResponse {
    cartsPage: PageResultDto<UserCartDto>;
}

export interface AdminOrdersListRequest {
    page: PageDto;
    criteria: OrderListCriteria;
}

export interface AdminOrdersListResponse {
    ordersPage: PageResultDto<AdminOrderDto>;
}

export interface AdminOrdersUpdateRequest {
    order: AdminOrderDto;
}

export interface CortonaPartLinkDto {
    resourceId: string;
    viewBookmark: string;
    partRefId: string;
}

export interface UserCartAddItemsRequest {
    itemsToAdd: UserCartItemValue[];
}

export interface UserCartAddItemsResponse {
    cart: UserCartDto;
}

export interface UserCartReadResponse {
    cart: UserCartDto;
}

export interface UserCartRemoveItemsRequest {
    itemsToRemove: UserCartItemId[];
}

export interface UserCartRemoveItemsResponse {
    cart: UserCartDto;
}

export interface UserCartUpdateRequest {
    cart: UserCartDto;
}

export interface UserCartUpdateResponse {
    cart: UserCartDto;
}

export interface AdminPartCheckRequest {
    partId: PartId;
}

export interface AdminPartCheckResponse {
    exists: boolean;
}

export interface AdminPartCreateRequest {
    partValue: PartValue;
}

export interface AdminPartCreateResponse {
    partValue: PartValue;
}

export interface AdminPartOptionAddRequest {
    optionCode: string;
    description: string;
}

export interface AdminPartOptionsListResponse {
    options: PartOptionValue[];
}

export interface AdminPartSubstituteAddRequest {
    id: number;
    substituteNameId: string;
    substituteType: SubstituteType;
    priority: number;
    effectiveFrom: Date;
    notes: string;
}

export interface AdminPartSubstitutesListResponse {
    substitutes: PartSubstituteValue[];
}

export interface AdminPartUpdateRequest {
    partValue: PartValue;
}

export interface AdminPartUpdateResponse {
    partValue: PartValue;
}

export interface AdminPartsImportResponse {
    result: PartsImportResult;
}

export interface AdminPartsListRequest {
    page: PageDto;
    criteria: PartCriteria;
}

export interface AdminPartsListResponse {
    parts: PageResultDto<PartValue>;
}

export interface ProductCreateRequest {
    urlId: string;
    name: string;
    filterId: string;
    thumbnail: string;
    menuTemplateId: number;
}

export interface ProductCreateResponse {
    productId: string;
}

export interface ProductListRequest {
    page: PageDto;
    filter: ProductListFilterValue;
}

export interface ProductListResponse {
    productList: PageResultDto<ProductValue>;
}

export interface ProductSaveRequest {
    product: ProductValue;
}

export interface ProductSaveResponse {
    product: ProductValue;
}

export interface AdminProductionImportResponse {
    job: ImportJobValue;
}

export interface AdminProductionJobItemsResponse {
    items: PageResultDto<ImportJobItemValue>;
}

export interface AdminProductionJobListRequest {
    page: PageDto;
}

export interface AdminProductionJobListResponse {
    jobs: PageResultDto<ImportJobValue>;
}

export interface AdminProductionUnitListCriteria {
    serialNumber: string;
    variantCode: string;
    productCode: string;
    batchId: string;
}

export interface AdminProductionUnitListRequest {
    criteria: AdminProductionUnitListCriteria;
    page: PageDto;
}

export interface AdminProductionUnitListResponse {
    units: PageResultDto<ProductionUnitValue>;
}

export interface AdminResourceDictLanguagesResponse {
    langs: ResourceDictLangValue[];
}

export interface AdminResourceDictPropertiesListRequest {
    criteria: ResourceDictPropertyListCriteria;
}

export interface AdminResourceDictPropertiesListResponse {
    resourceProperties: ResourceDictPropertyValue[];
}

export interface AdminResourceDictPropertiesUpdateRequest {
    propertyValue: ResourceDictPropertyValue;
}

export interface AdminResourceDictPropertiesUpdateResponse {
}

export interface AdminResourceDictPropertyCodeCheckCheckRequest {
    code: string;
}

export interface AdminResourceDictPropertyCodeCheckCheckResponse {
    exists: boolean;
}

export interface AdminResourceDictPropertyCreateRequest {
    propertyValue: ResourceDictPropertyValue;
}

export interface AdminResourceDictPropertyCreateResponse {
}

export interface AdminResourceDictPropertyDeleteRequest {
    code: string;
}

export interface AdminResourceDictPropertyDeleteResponse {
}

export interface AdminResourcesDictPropertyOptionsRequest {
    userText: string;
    propertyCode: string;
    limit: number;
}

export interface AdminResourceFilterCreateRequest {
    filter: ResourceFilterValue;
}

export interface AdminResourceFilterCreateResponse {
    filterId: string;
}

export interface AdminResourceFilterDeleteRequest {
    filterId: string;
}

export interface AdminResourceFilterListMenuFiltersResponse {
    filters: ResourceFilterValue[];
}

export interface AdminResourceFilterListRequest {
    page: PageDto;
    filter: ResourceFilterValue;
}

export interface AdminResourceFilterListResponse {
    filters: PageResultDto<ResourceFilterValue>;
}

export interface AdminResourceRecalculatePropertiesResponse {
    calculatedExternalId: string;
}

export interface AdminResourceUpdateExternalIdRequest {
    externalId: string;
}

export interface AdminResourceUpdateRequest {
    name: string;
    externalId: string;
    status: ResourceStatus;
    replacePublished: boolean;
    translations: LanguageTranslationValue[];
    metadata: ResourceMetadataDto;
    permissions: ResourcePermissionDictId[];
}

export interface AdminResourceUpdateResponse {
    resourceDto?: ResourceDto;
    updateStatus: ResourceUpdateStatus;
}

export interface AdminResourcesListRequest {
    page: PageDto;
    filter: ResourceFilterValue;
    lang: string;
}

export interface AdminResourcesListResponse {
    resourcesList: PageResultDto<ResourceDto>;
}

export interface AdminResourcesReadRequest {
    resourceId: ResourceId;
}

export interface AdminResourcesReadResponse {
    resourceValue: ResourceValue;
    translations: LanguageTranslationValue[];
    resourceMetadata: ResourceMetadataDto;
    permissions: ResourcePermissionDto[];
}

export interface ResourceMetadataDto {
    resourceProperties: ResourceFilterPropertyValue[];
    thumbnailId: string;
}

export interface ResourceDictPropertyOptionValue {
    code: string;
    defaultName: string;
    translations: LanguageTranslationValue[];
}

export interface ResourceDictPropertyValue {
    code: string;
    description: string;
    defaultName: string;
    valueOpen: boolean;
    type: ResourcePropertyValueType;
    propertyOptions: ResourceDictPropertyOptionValue[];
    translations: LanguageTranslationValue[];
}

export interface AdminResourcePermissionDictCreateRequest {
    resourcePermission: ResourcePermissionDictValue;
}

export interface AdminResourcePermissionDictCreateResponse {
    resourcePermission: ResourcePermissionDictValue;
    auditInfo: AuditUserInfoValue;
}

export interface AdminResourcePermissionDictDeleteRequest {
    resourcePermissionDict: ResourcePermissionDictValue;
}

export interface AdminResourcePermissionDictDeleteResponse {
    resourcePermissionDictId: ResourcePermissionDictId;
}

export interface AdminResourcePermissionDictListRequest {
    page: PageDto;
    criteria: ResourcePermissionDictCriteria;
}

export interface AdminResourcePermissionDictListResponse {
    permissions: PageResultDto<ResourcePermissionDictDto>;
}

export interface AdminResourcePermissionDictUpdateRequest {
    resourcePermission: ResourcePermissionDictValue;
}

export interface AdminResourcePermissionDictUpdateResponse {
    resourcePermission: ResourcePermissionDictValue;
    auditInfo: AuditUserInfoValue;
}

export interface ResourcePermissionDictDto {
    resourcePermissionDict: ResourcePermissionDictValue;
    auditInfo: AuditUserInfoValue;
}

export interface UploadChildrenListRequest {
    parentUploadId: UploadId;
    page: PageDto;
}

export interface UploadChildrenListResponse {
    uploadList: PageResultDto<UploadValue>;
}

export interface UploadsListRequest {
    page: PageDto;
    filter: UploadsFilterValue;
}

export interface UploadsListResponse {
    uploadList: PageResultDto<UploadValue>;
}

export interface ApiMenuReadMenuItemDto {
    id: number;
    urlId: string;
    parentId: number;
    parentUrlId: string;
    name: string;
    url: string;
    isLeaf: boolean;
    actionType: MenuActionType;
    contentLayout: MenuContentLayout;
    sortNo: number;
    pathItems: ApiMenuPathItemDto[];
    children: ApiMenuReadMenuItemDto[];
    resourceId: string;
    thumbnailUrl: string;
    totalChildElements: number;
    active: boolean;
    mimeType: string;
}

export interface PageResultDto<T> {
    pageContent: T[];
    totalElements: number;
}

export interface ApiResourceDto {
    id: string;
    name: string;
    externalId: string;
    type: ResourceType;
    status: ResourceStatus;
    lang: string;
    mimeType: string;
    path: string;
    thumbnailUrl: string;
    additionalParams: { [index: string]: string };
    cortonaIpc?: ApiCortonaIpcDescriptionDto;
    partsMap: { [index: string]: ApiPartDto[] };
}

export interface ApiOrderAddressDto {
    firstName: string;
    lastName: string;
    companyName: string;
    taxId: string;
    email: string;
    phoneNumber: string;
    country: string;
    state: string;
    postalCode: string;
    city: string;
    addressLine1: string;
    addressLine2: string;
}

export interface ApiOrderItemDto {
    partName: string;
    partNumber: string;
    optionCode: string;
    serialNumber: string;
    quantity: number;
    position: number;
    resourceId: string;
    note: string;
    manuallyAdded: boolean;
    price: Amount;
}

export interface PageDto {
    page: number;
    itemsPerPage: number;
    sortBy: SortItem[];
    groupBy: string[];
    groupDesc: boolean[];
    mustSort: boolean;
    multiSort: boolean;
}

export interface UserAddressData {
    id: number;
    version: number;
    type: RetailUserAddressType;
    name: string;
    taxId: string;
    country: string;
    zip: string;
    city: string;
    state: string;
    lineOne: string;
    lineTwo: string;
    phone: string;
    email: string;
}

export interface OrderAddressData {
    type: OrderAddressType;
    firstName: string;
    lastName: string;
    email: string;
    companyName: string;
    taxId: string;
    country: string;
    zip: string;
    city: string;
    state: string;
    lineOne: string;
    lineTwo: string;
    phone: string;
}

export interface Amount {
    value: number;
    currency: string;
}

export interface OrderItem {
    partName: string;
    partNumber: string;
    quantity: number;
    position: number;
    resourceId: string;
    manuallyAdded: boolean;
    price: Amount;
    note: string;
}

export interface OrganizationAddressId {
    id: number;
}

export interface OrganizationNameValue {
    id: number;
    name: string;
}

export interface OrganizationListCriteria {
    id: number;
    name: string;
}

export interface OrganizationValue {
    id: number;
    version: number;
    name: string;
    taxId: string;
    phone: string;
    menuList: OrganizationMenuValue[];
}

export interface UserId extends Serializable {
    id: number;
}

export interface UserAddressValue {
    id: number;
    version: number;
    userId: UserId;
    type: RetailUserAddressType;
    name: string;
    taxId: string;
    country: string;
    state: string;
    zip: string;
    city: string;
    addressLine1: string;
    addressLine2: string;
    phone: string;
    email: string;
}

export interface UserValue {
    userId: UserId;
    userType: UserType;
    email: string;
    firstName: string;
    lastName: string;
    emailVerified: boolean;
    accountStatus: UserAccountStatus;
    password: string;
    passwordChangeRequired: boolean;
    lastLoginSuccess: Date;
    lastLoginFailed: Date;
    loginFailedCounter: number;
    locked: boolean;
    lockDate: Date;
    autoLockUntil: Date;
    expiry: Date;
    organizationId: number;
    companyId: number;
    langKey: string;
    userTimezone: string;
    userDateFormatter: string;
    userRoles: string[];
    resourcePermissionGroups: UserResourcePermissionGroupValue[];
    audit: AuditInfoValue;
    auditInfo: AuditUserInfoValue;
    fullName: string;
    emailAddressFormatted: string;
}

export interface UserCreationResult {
    user: UserValue;
    activationLink: string;
}

export interface UserListCriteria {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    statuses: UserAccountStatus[];
    predefinedFilter: UserListPredefinedFilter;
}

export interface UserResourcePermissionGroupCriteria {
    groupName: string;
    permissionName: string;
    permissionDescription: string;
}

export interface UserResourcePermissionGroupValue {
    groupId: UserResourcePermissionGroupId;
    version: number;
    name: string;
    auditInfo: AuditInfoValue;
    elementList: UserResourcePermissionGroupElemValue[];
}

export interface EmailHistoryListCriteria {
    emailId: EmailId;
    emailCode: EmailCode;
    status: EmailStatus;
    lang: string;
    sender: string;
    recipient: string;
    ccRecipient: string;
    bccRecipient: string;
    subject: string;
}

export interface EmailId {
    id: string;
}

export interface ListDictionaryPropertiesCriteria {
    resourceTypes: ResourceType[];
    propertyCode: string;
    valueTemplate: string;
}

export interface MenuId {
    id: number;
}

export interface MenuItemValue {
    menuId: MenuId;
    version: number;
    urlId: string;
    parentId: MenuId;
    parentUrlId: string;
    name: string;
    isLeaf: boolean;
    actionType: MenuActionType;
    contentLayout: MenuContentLayout;
    sortNo: number;
    pathItems: MenuItemNameValue[];
    children: MenuItemValue[];
    menuFilters: MenuItemFilterValue[];
    active: boolean;
    thumbnail: ResourceId;
    resourceId: ResourceId;
    publicDefault: boolean;
    translations: LanguageTranslationValue[];
}

export interface MenuItemListCriteria {
    id: number;
    parentId: number;
    name: string;
    actionType: MenuActionType;
    contentLayout: MenuContentLayout;
    active: boolean;
}

export interface MenuItemNameValue {
    menuId: MenuId;
    name: string;
    fullPath: string;
    parentId: MenuId;
}

export interface UserCartDto {
    version: number;
    userCartId: UserCartId;
    userId: UserId;
    userEmail: string;
    status: UserCartStatus;
    note: string;
    items: UserCartItemDto[];
    auditInfo: AuditUserInfoValue;
}

export interface UserCartListCriteria {
    userId: number;
    userEmail: string;
    status: UserCartStatus;
}

export interface OrderListCriteria {
    userId: UserId;
    orderId: OrderId;
    email: string;
    taxId: string;
    status: OrderStatus;
}

export interface AdminOrderDto {
    version: number;
    orderId: OrderId;
    status: OrderStatus;
    billingAddress: OrderAddressValue;
    shippingAddress: OrderAddressValue;
    userId: UserId;
    note: string;
    items: OrderItemValue[];
    auditInfo: AuditUserInfoValue;
}

export interface UserCartItemValue {
    itemId: UserCartItemId;
    name: string;
    partNumber: string;
    optionCode: string;
    serialNumber: string;
    quantity: number;
    resourceId: ResourceId;
    note: string;
    price: Amount;
    manuallyAdded: boolean;
}

export interface UserCartItemId {
    id: string;
}

export interface PartId {
    id: string;
}

export interface PartValue {
    partId: PartId;
    version: number;
    description: string;
    producerName: string;
    producerPartId: string;
    translations: PartTranslationValue[];
    auditInfo: AuditUserInfoValue;
}

export interface PartOptionValue {
    optionCode: string;
    description: string;
}

export interface PartSubstituteValue {
    id: number;
    substituteNameId: string;
    substituteType: SubstituteType;
    priority: number;
    effectiveFrom: Date;
    notes: string;
}

export interface PartsImportResult {
    insertedParts: number;
    updatedParts: number;
    errors: number;
}

export interface PartCriteria {
    nameId: string;
    description: string;
}

export interface ProductListFilterValue {
    productId: ProductId;
    productName: string;
}

export interface ProductValue {
    uuid: ProductId;
    urlId: string;
    name: string;
    filterId: ResourceFilterId;
    thumbnailId: ResourceId;
    menuTemplateId: MenuId;
    updatedOn: Date;
    updatedBy: number;
}

export interface ImportJobValue {
    id: ImportJobId;
    sourceFormat: string;
    sourceFilename: string;
    status: ImportJobStatus;
    startedAt: Date;
    finishedAt: Date;
    totalUnits: number;
    insertedUnits: number;
    updatedUnits: number;
    errorCount: number;
    warningCount: number;
}

export interface ImportJobItemValue {
    id: string;
    serialNumber: string;
    severity: ImportItemSeverity;
    message: string;
}

export interface ProductionUnitValue {
    id: ProductionUnitId;
    serialNumber: string;
    variantCode: string;
    productCode: string;
    resourceExternalId: string;
    producedAt: Date;
    batchId: string;
    status: string;
    fittedOptions: string[];
    parts: ProductionUnitPartValue[];
}

export interface ResourceDictLangValue {
    lang: string;
    description: string;
    translation: boolean;
    resourceLang: boolean;
    active: boolean;
}

export interface ResourceDictPropertyListCriteria {
    code: string;
    description: string;
}

export interface ResourceFilterValue {
    filterId: ResourceFilterId;
    filterName: string;
    filterDescription: string;
    filterType: ResourceFilterType;
    criteria: ResourceFilterCriteriaValue;
    filterGroupingType: FilterGroupingType;
    updatedOn: Date;
    updatedBy: number;
}

export interface LanguageTranslationValue {
    langCode: string;
    name: string;
}

export interface ResourcePermissionDictId {
    id: number;
}

export interface ResourceDto {
    uuid: string;
    relativePath: string;
    name: string;
    externalId: string;
    type: ResourceType;
    lang: string;
    status: ResourceStatus;
    mimeType: string;
    size: number;
    hash: string;
    created: Date;
    modified: Date;
    createdBy: string;
    modifiedBy: string;
    defaultResource: boolean;
    path: string;
    metadataJson: string;
    createdTimestamp: number;
    modifiedTimestamp: number;
}

export interface ResourceId {
    uuid: string;
}

export interface ResourceValue {
    uuid: string;
    parentId: string;
    relativePath: string;
    name: string;
    sourceName: string;
    externalId: string;
    type: ResourceType;
    lang: string;
    status: ResourceStatus;
    mimeType: string;
    size: number;
    hash: string;
    defaultResource: boolean;
    created: Date;
    modified: Date;
    createdBy: number;
    modifiedBy: number;
    resourceId: ResourceId;
    parentResourceId: ResourceId;
    createdTimestamp: number;
}

export interface ResourcePermissionDto {
    resourcePermissionValue: ResourcePermissionValue;
    resourcePermissionDictValue: ResourcePermissionDictValue;
}

export interface ResourceFilterPropertyValue {
    propertyCode: string;
    options: string[];
}

export interface ResourcePermissionDictValue {
    id: ResourcePermissionDictId;
    version: number;
    name: string;
    description: string;
    auditInfo: AuditInfoValue;
}

export interface AuditUserInfoValue {
    createdOn: number;
    createdOnString: string;
    createdByUserName: string;
    createdByUserEmail: string;
    updatedOn: number;
    updatedOnString: string;
    updatedByUserName: string;
    updatedByUserEmail: string;
}

export interface ResourcePermissionDictCriteria {
    id: number;
    name: string;
    description: string;
}

export interface UploadId {
    id: number;
}

export interface UploadValue {
    id: number;
    version: number;
    externalId: string;
    serverName: string;
    absoluteFilePath: string;
    name: string;
    relativeName: string;
    mimeType: string;
    size: number;
    hash: string;
    defaultResource: boolean;
    resourceId: string;
    uploadStatus: UploadStatus;
    uploadType: UploadType;
    resourceType: ResourceType;
    auditInfo: AuditUserInfoValue;
}

export interface UploadsFilterValue {
    uploadId: UploadId;
    name: string;
    uploadType: UploadType;
    uploadStatus: UploadStatus;
}

export interface ApiMenuPathItemDto {
    id: number;
    parentId: number;
    name: string;
    fullPath: string;
}

export interface ApiCortonaIpcDescriptionDto {
    metadata: { [index: string]: string };
    views: ApiCortonaIpcViewDto[];
}

export interface ApiPartDto {
    sequence: number;
    partItemNumber: string;
    partId: string;
    name: string;
    viewItemId: string;
    partRefId: string;
    indent: number;
    quantity: number;
    partType: PartType;
}

export interface SortItem {
    key: string;
    order: string;
    desc: boolean;
}

export interface OrganizationMenuValue {
    menuId: number;
    menuName: string;
}

export interface Serializable {
}

export interface AuditInfoValue {
    createdOn: Date;
    createdBy: number;
    updatedOn: Date;
    updatedBy: number;
}

export interface UserResourcePermissionGroupId {
    id: number;
}

export interface UserResourcePermissionGroupElemValue {
    id: UserResourcePermissionGroupElemId;
    version: number;
    resourcePermissionDictId: ResourcePermissionDictId;
    canCreate: boolean;
    canDelete: boolean;
    canUpdate: boolean;
    canRead: boolean;
    auditInfo: AuditInfoValue;
    dictValue: ResourcePermissionDictValue;
}

export interface MenuItemFilterValue {
    menuId: MenuId;
    filterId: ResourceFilterId;
    filterType: FilterGroupingType;
}

export interface UserCartId {
    id: string;
}

export interface UserCartItemDto {
    itemId: UserCartItemId;
    name: string;
    partNumber: string;
    optionCode: string;
    serialNumber: string;
    quantity: number;
    resourceId: ResourceRef;
    note: string;
    price: Amount;
    manuallyAdded: boolean;
}

export interface OrderId {
    id: number;
}

export interface OrderAddressValue {
    addressType: OrderAddressType;
    firstName: string;
    lastName: string;
    companyName: string;
    taxId: string;
    email: string;
    phoneNumber: string;
    country: string;
    state: string;
    postalCode: string;
    city: string;
    addressLine1: string;
    addressLine2: string;
}

export interface OrderItemValue {
    itemId: UserCartItemId;
    position: number;
    name: string;
    partNumber: string;
    optionCode: string;
    serialNumber: string;
    quantity: number;
    resourceId: ResourceId;
    note: string;
    price: Amount;
    manuallyAdded: boolean;
}

export interface PartTranslationValue {
    langCode: string;
    name: string;
    descriptionHtml: string;
}

export interface ProductId {
    id: string;
}

export interface ResourceFilterId {
    id: string;
}

export interface ImportJobId {
}

export interface ProductionUnitId {
}

export interface ProductionUnitPartValue {
    partNumber: string;
    optionCode: string;
    parentPartNumber: string;
    partPath: string;
    partLevel: number;
    partDescription: string;
}

export interface ResourceFilterCriteriaValue {
    data: ResourceFilterDataValue;
    contentInfo: ResourceFilterPropertyValue[];
    properties: ResourceFilterPropertyValue[];
}

export interface ResourcePermissionValue {
    resourceId: ResourceId;
    resourcePermissionDictId: ResourcePermissionDictId;
}

export interface ApiCortonaIpcViewDto {
    id: string;
    hidden: boolean;
    description: string;
    metadata: { [index: string]: string };
    headers: ContentInfoCortonaIpcViewTableHeader[];
    parts: ApiCortonaIpcPartDto[];
}

export interface UserResourcePermissionGroupElemId {
    id: number;
}

export interface ResourceRef {
    uuid: string;
    name: string;
}

export interface ResourceFilterDataValue {
    uuid: string;
    resourceName: string;
    resourceExternalId: string;
    resourceType: ResourceType;
    resourceStatus: ResourceStatus;
    resourceStatusList: ResourceStatus[];
}

export interface ContentInfoCortonaIpcViewTableHeader {
    value: string;
    text: string;
    width: string;
}

export interface ApiCortonaIpcPartDto {
    sequence: number;
    viewPartSequence: number;
    partItemNumber: string;
    partId: string;
    description: string;
    viewItemId: string;
    partRefId: string;
    indent: number;
    viewIndent: number;
    quantity: number;
    viewQuantity: number;
    partType: PartType;
    url: string;
    tableCells: { [index: string]: any };
}

export enum EmailGroup {
    ORDER = "ORDER",
    USER = "USER",
}

export enum ResourcePropertyValueType {
    NUMBER = "NUMBER",
    TEXT = "TEXT",
    BOOLEAN = "BOOLEAN",
}

export enum ResourceType {
    FILE = "FILE",
    CORTONA_IPC = "CORTONA_IPC",
    CORTONA_MANUAL = "CORTONA_MANUAL",
    CORTONA_WORK_INSTRUCTION = "CORTONA_WORK_INSTRUCTION",
}

export enum OrganizationAddressType {
    MAIN = "MAIN",
    LEGAL = "LEGAL",
    CORRESPONDENCE = "CORRESPONDENCE",
    SHIPPING = "SHIPPING",
    BILLING = "BILLING",
}

export enum UserType {
    SYSTEM = "SYSTEM",
    ADMIN = "ADMIN",
    ORGANIZATION_USER = "ORGANIZATION_USER",
    RETAIL_USER = "RETAIL_USER",
    CMS_USER = "CMS_USER",
}

export enum OrderStatus {
    NEW = "NEW",
    PROCESSING = "PROCESSING",
    CLOSED = "CLOSED",
}

export enum RetailUserAddressType {
    SHIPPING = "SHIPPING",
    BILLING = "BILLING",
}

export enum EmailCode {
    USER_EMAIL_CONFIRMATION = "USER_EMAIL_CONFIRMATION",
    USER_PASSWORD_RESET = "USER_PASSWORD_RESET",
    USER_REGISTRATION_ACCOUNT_EXISTS = "USER_REGISTRATION_ACCOUNT_EXISTS",
    USER_EMAIL_CONFIRMED = "USER_EMAIL_CONFIRMED",
    ADMIN_USER_REGISTERED = "ADMIN_USER_REGISTERED",
    ADMIN_USER_EMAIL_CONFIRMED = "ADMIN_USER_EMAIL_CONFIRMED",
    ORDER_SUBMITTED = "ORDER_SUBMITTED",
    ORDER_SUBMITTED_CONFIRMATION = "ORDER_SUBMITTED_CONFIRMATION",
}

export enum MenuActionType {
    MENU_TEMPLATE_ROOT = "MENU_TEMPLATE_ROOT",
    MENU = "MENU",
    FILTER = "FILTER",
    CORTONA_MODEL = "CORTONA_MODEL",
    FILE = "FILE",
    MENU_RESOURCE = "MENU_RESOURCE",
}

export enum SubstituteType {
    FULL_REPLACEMENT = "FULL_REPLACEMENT",
    FUNCTIONAL_EQUIVALENT = "FUNCTIONAL_EQUIVALENT",
    SUPERSEDED_BY = "SUPERSEDED_BY",
}

export enum ResourceStatus {
    NEW = "NEW",
    DRAFT = "DRAFT",
    PUBLISHED = "PUBLISHED",
    DEPENDENT = "DEPENDENT",
    REPLACED = "REPLACED",
    NOT_PUBLISHED = "NOT_PUBLISHED",
}

export enum ResourceUpdateStatus {
    SAVED = "SAVED",
    EXISTS_PUBLISHED_SAME_EXTERNAL_ID = "EXISTS_PUBLISHED_SAME_EXTERNAL_ID",
}

export enum MenuContentLayout {
    TREE = "TREE",
    CARDS = "CARDS",
    TABLE = "TABLE",
    NONE = "NONE",
}

export enum OrderAddressType {
    REGISTERED = "REGISTERED",
    OPERATING = "OPERATING",
    SHIPPING = "SHIPPING",
    BILLING = "BILLING",
}

export enum UserAccountStatus {
    NEW = "NEW",
    ACTIVE = "ACTIVE",
    LOCKED = "LOCKED",
    NOT_EXISTS = "NOT_EXISTS",
    DELETED = "DELETED",
}

export enum UserListPredefinedFilter {
    PENDING_ACTIVATION = "PENDING_ACTIVATION",
}

export enum EmailStatus {
    NEW = "NEW",
    SENT = "SENT",
    ERROR = "ERROR",
}

export enum UserCartStatus {
    ACTIVE = "ACTIVE",
    ORDERED = "ORDERED",
    CANCELED = "CANCELED",
}

export enum ImportJobStatus {
    PENDING = "PENDING",
    COMPLETED = "COMPLETED",
    COMPLETED_WITH_WARNINGS = "COMPLETED_WITH_WARNINGS",
    FAILED = "FAILED",
}

export enum ImportItemSeverity {
    INFO = "INFO",
    WARNING = "WARNING",
    ERROR = "ERROR",
}

export enum ResourceFilterType {
    MENU_FILTER = "MENU_FILTER",
    PRODUCT_FILTER = "PRODUCT_FILTER",
}

export enum FilterGroupingType {
    MANDATORY = "MANDATORY",
    OPTION = "OPTION",
}

export enum UploadStatus {
    NEW = "NEW",
    PROCESSING = "PROCESSING",
    UPLOADED = "UPLOADED",
    COMPLETED = "COMPLETED",
    ERROR = "ERROR",
}

export enum UploadType {
    SINGLE_FILE = "SINGLE_FILE",
    ZIP_ARCHIVE = "ZIP_ARCHIVE",
}

export enum PartType {
    PART = "PART",
    RESOURCE = "RESOURCE",
}
